import { Locales } from 'types/locale';

import { select as selectLocale } from 'utils/locale';

const translationsModels = selectLocale({
    [Locales.En]: require('locales/models/en.json'),
    [Locales.Pl]: require('locales/models/pl.json'),
});

export enum Subjects {
    Resignation = 'resignation',
    EffectsFree = 'effectsFree',
    SideEffects = 'sideEffects',
    Other = 'other',
}

export const subjectOptions = [{
    value: Subjects.Resignation,
    label: translationsModels?.complaints?.subjects?.resignation,
}, {
    value: Subjects.EffectsFree,
    label: translationsModels?.complaints?.subjects?.effectsFree,
}, {
    value: Subjects.SideEffects,
    label: translationsModels?.complaints?.subjects?.sideEffects,
}, {
    value: Subjects.Other,
    label: translationsModels?.complaints?.subjects?.other,
}];